import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginRequest } from '../../models/authentication/login-request';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {

  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  errorMessage: string = '';

  ngOnInit(): void {
    this.isLoggedIn();
  }

  credentials: LoginRequest = {
    email: '',
    password: ''
  };

  isLoggedIn(): boolean {
    return this.authService.currentUserValue != null;
  }

  login() {
    this.errorMessage = '';
    this.authService.logout(); // Clear any stale session before login

    this.authService.login(this.credentials).subscribe(
      {
        next: () => {
          let redirectUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
          this.router.navigate([redirectUrl]);
        },
        error: (error) => {
          this.errorMessage = error.error;
        }
      }
    ); 

  }


}
